__turbopack_context__.v({
  "className": "heading_2b4ea010-module__dS7iJW__className",
});
